import React from 'react';
import './Styles/navbar.css';
import { Link, useMatch, useResolvedPath } from 'react-router-dom';


export const NavBar = () => {
  return (
    <nav className='nav exp'>
        <ul>
            <BotonLink to="/" className='nav-btn'>
                <span className="material-symbols-outlined fixV">person</span>Inicio
            </BotonLink>

            <BotonLink to="/Proyectos" className='nav-btn'>
                <span className="material-symbols-outlined fixV">construction</span>Proyectos
            </BotonLink>

            <BotonLink to="/GameJams" className='nav-btn'>
                <span className="material-symbols-outlined fixV">sports_esports</span><span className='dis'>Game</span> Jams
            </BotonLink>
        </ul>
    </nav>
  )
}

function BotonLink({to, children,...props}) {
    const resolvedPath = useResolvedPath(to)
    const isActive = useMatch({ path: resolvedPath.pathname, end: true})
    return (
        <Link to={to} {...props} className={isActive ? 'active' : ''}>
            {children}
        </Link>
    )
}